import { AUTH_SCREENS, ROUTES } from '@/constants';

type AuthScreen = (typeof AUTH_SCREENS)[keyof typeof AUTH_SCREENS];

interface AuthScreenUrlOptions {
	screen: AuthScreen;
	email?: string;
	name?: string;
	redirect?: string | null;
}

export function getCurrentRedirectTarget() {
	if (typeof window === 'undefined') return ROUTES.HOME;

	return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function buildAuthRedirectUrl(redirect = getCurrentRedirectTarget()) {
	const params = new URLSearchParams();
	params.set('redirect', redirect);

	return `${ROUTES.AUTH}?${params.toString()}`;
}

export function buildAuthScreenUrl({ screen, email, name, redirect }: AuthScreenUrlOptions) {
	const params = new URLSearchParams();
	params.set('screen', screen);

	if (email) params.set('email', email);
	if (name) params.set('name', name);
	if (redirect) params.set('redirect', redirect);

	return `${ROUTES.AUTH}?${params.toString()}`;
}

export function checkIsProbabilityFlow(redirectUrl?: string | null) {
	if (!redirectUrl) return false;
	return redirectUrl.includes('probability-events');
}
